import { ServiceState, ServiceStateItem } from '@/lib/types/store/services'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

const initialState: ServiceState = {
  items: [],
  loading: false,
  error: null,
  selectedService: null,
  filterParams: null,
  lastLoadedLocationId: null
}

const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    setServices: (state, action: PayloadAction<{ services: ServiceStateItem[]; locationId: string }>) => {
      // Always update services regardless of array length for public/all locations
      state.items = action.payload.services || []
      state.lastLoadedLocationId = action.payload.locationId

      state.loading = false
      state.error = null
    },
    clearServices: (state) => {
      state.items = []
      state.lastLoadedLocationId = null
      state.loading = false
      state.error = null
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
    setSelectedService: (state, action: PayloadAction<ServiceStateItem | null>) => {
      state.selectedService = action.payload
    },
    setFilterParams: (state, action: PayloadAction<Record<string, unknown> | null>) => {
      state.filterParams = action.payload
    },
    clearFilterParams: (state) => {
      state.filterParams = null
    }
  }
})

export const {
  setServices,
  clearServices,
  setLoading,
  setError,
  setSelectedService,
  setFilterParams,
  clearFilterParams
} = servicesSlice.actions

export default servicesSlice.reducer
